export const recruitmentConfig = {
  default: {
    recruitmentSpeed: 0,
    troopsPerBatch: 0,
    hoursPerBatch: 0,
    dukePercent: 0.952237146,
    baronPercent: 0.975336153,
    nationalRecruitmentList: [
      { level: 10, percentage: 26, calcPercent: 0.817291476 },
      { level: 9, percentage: 24, calcPercent: 0.831345978 },
      { level: 8, percentage: 22, calcPercent: 0.84540048 },
      { level: 7, percentage: 20, calcPercent: 0.859454982 },
      { level: 6, percentage: 18, calcPercent: 0.873509484 },
      { level: 5, percentage: 16, calcPercent: 0.887563985 },
      { level: 4, percentage: 14, calcPercent: 0.901618487 },
      { level: 3, percentage: 12, calcPercent: 0.915672989 },
      { level: 2, percentage: 10, calcPercent: 0.929727491 },
      { level: 1, percentage: 8, calcPercent: 0.943781993 },
      { level: 0, percentage: 0, calcPercent: 1 }
    ],
    troopsPoints: [
      { value: 1, desc: 't1', points: 1, bp: 1 },
      { value: 2, desc: 't2', points: 2, bp: 1.5 },
      { value: 3, desc: 't3', points: 4, bp: 2.1 },
      { value: 4, desc: 't4', points: 7, bp: 2.8 },
      { value: 5, desc: 't5', points: 12, bp: 3.6 },
      { value: 6, desc: 't6', points: 20, bp: 4.5 },
      { value: 7, desc: 't7', points: 30, bp: 5.5 },
      { value: 8, desc: 't8', points: 42, bp: 6.7 },
      { value: 9, desc: 't9', points: 70, bp: 8.1 },
      { value: 10, desc: 't10', points: 96, bp: 9.7 },
      { value: 11, desc: 't11', points: 120, bp: 11.6 },
      { value: 12, desc: 't12', points: 150, bp: 13.9 },
      { value: 13, desc: 't13', points: 190, bp: 16.5 },
      { value: 14, desc: 't14', points: 230, bp: 19.4 }
    ],
    profiles: [{ value: 'default' }, { value: 'player' }],
    mode: [{ value: 'custom' }, { value: 'player (soon)' }]
  }
}

export const defaultConfig = {
  recruitmentSpeed: 247.7,
  allianceSkillBuff: 0,
  kingBuff: 0,
  troopsBatch: 2300,
  tierTime: {
    1: 2.566,
    2: 4.618,
    3: 7.439,
    4: 10.261,
    5: 14.108,
    6: 19.495,
    7: 25.651,
    8: 33.346,
    9: 42.067,
    10: 51.814,
    11: 60.555,
    12: 73.206,
    13: 87.343
  }
}

export const defaultTierDiff = {
  14: 1.3988417259
}

export const defaultTierDiffGems = {
  14: 1.3695620394
}

export const recruitmentTemplates = [
  {
    recruitmentSpeed: 247.7,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 2300,
    tierTime: {
      13: 73.0239130434783,
      12: 61.2052173913044,
      11: 50.6526086956522,
      10: 42.6326086956522,
      9: 34.6126086956522,
      8: 27.4369565217391,
      7: 21.1052173913043,
      6: 16.04,
      5: 11.6082608695652,
      4: 8.44217391304348,
      3: 6.12086956521739,
      2: 3.79913043478261,
      1: 2.11086956521739
    },
    gemQty: {
      13: 1.57826086956522,
      12: 1.34217391304348,
      11: 1.13086956521739,
      10: 0.970434782608696,
      9: 0.805217391304348,
      8: 0.649565217391304,
      7: 0.512608695652174,
      6: 0.402608695652174,
      5: 0.304782608695652,
      4: 0.231304347826087,
      3: 0.17695652173913,
      2: 0.12304347826087,
      1: 0.08
    }
  },
  {
    recruitmentSpeed: 238.2,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 2486,
    tierTime: {
      14: 108.17367569078154,
      13: 77.33089004131881,
      12: 64.8150864322456,
      11: 53.6399363352728,
      10: 45.14697908761276,
      9: 36.65402183995281,
      8: 29.05502361075973,
      7: 22.350300193945486,
      6: 16.986315034994487,
      5: 12.292541108019238,
      4: 8.940137026730756,
      3: 6.481776709671978,
      2: 4.023331646850496,
      1: 2.2350978160047186
    },
    gemQty: {
      14: 2.298500204356553,
      13: 1.6782738848132188,
      12: 1.4279817016611838,
      11: 1.2045497090817077,
      10: 1.034291255586471,
      9: 0.8558908845602501,
      8: 0.6913711105489502,
      7: 0.5457159119655957,
      6: 0.42974787081541443,
      5: 0.3253651235348683,
      4: 0.24695674171515272,
      3: 0.1899009191331479,
      2: 0.13212876296483675,
      1: 0.08608820305253397
    }
  },
  {
    recruitmentSpeed: 235.9,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 2010,
    tierTime: {
      14: 109.632338308458,
      13: 78.373631840796,
      12: 65.6890547263682,
      11: 54.363184079602,
      10: 45.7557213930348,
      9: 37.1482587064677,
      8: 29.4467661691542,
      7: 22.6517412935323,
      6: 17.2154228855721,
      5: 12.4582089552239,
      4: 9.06069651741294,
      3: 6.56915422885572,
      2: 4.07761194029851,
      1: 2.26517412935323
    },
    gemQty: {
      14: 2.3273631840796,
      13: 1.70248756218905,
      12: 1.44875621890547,
      11: 1.22238805970149,
      10: 1.04975124378109,
      9: 0.8681592039801,
      8: 0.701492537313433,
      7: 0.553731343283582,
      6: 0.436318407960199,
      5: 0.330348258706468,
      4: 0.250746268656716,
      3: 0.193034825870647,
      2: 0.134328358208955,
      1: 0.0875621890547264
    }
  },
  {
    recruitmentSpeed: 230.7,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 2680,
    tierTime: {
      14: 113.23245617035144,
      13: 80.94729666252904,
      12: 67.84623187797456,
      11: 56.14850916170456,
      10: 47.137741185594734,
      9: 38.36823476030855,
      8: 30.413859389272982,
      7: 23.395445432539972,
      6: 17.780574427980593,
      5: 12.867324886215767,
      4: 9.358218349793823,
      3: 6.78477320108977,
      2: 4.211528936274835,
      1: 2.339705250365289
    },
    gemQty: {
      14: 2.4031625489424178,
      13: 1.7546941867600494,
      12: 1.4928015606979137,
      11: 1.2588607784700434,
      10: 1.0808262824087638,
      9: 0.8949807011547329,
      8: 0.7229571307784102,
      7: 0.5703699261826664,
      6: 0.44894091215277593,
      5: 0.34003725846460775,
      4: 0.25808362766321036,
      3: 0.19817005770664559,
      2: 0.1378573184699241,
      1: 0.08976731449222353
    }
  },
  {
    recruitmentSpeed: 222.8,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 1976,
    tierTime: {
      13: 84.8572874493927,
      12: 71.1234817813765,
      11: 58.8608299595142,
      10: 49.2373481781377,
      9: 40.2216599190283,
      8: 31.8830971659919,
      7: 24.5253036437247,
      6: 18.6391700404858,
      5: 13.4888663967611,
      4: 9.81022267206478,
      3: 7.11234817813765,
      2: 4.41497975708502,
      1: 2.45293522267207
    },
    gemQty: {
      13: 1.83400809716599,
      12: 1.55971659919028,
      11: 1.31427125506073,
      10: 1.12803643724696,
      9: 0.935728744939271,
      8: 0.755566801619433,
      7: 0.595647773279352,
      6: 0.468117408906883,
      5: 0.354757085020243,
      4: 0.269230769230769,
      3: 0.205971659919028,
      2: 0.143218623481781,
      1: 0.0931174089068826
    }
  },
  {
    recruitmentSpeed: 210,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 1797,
    tierTime: {
      1: 2.5002782415136338,
      2: 4.500834724540901,
      3: 7.250973845297718,
      4: 10.001112966054535,
      5: 13.751252086811352,
      6: 19.001669449081803,
      7: 25.00222593210907,
      8: 32.50306065664997,
      9: 41.00389538119087,
      10: 50.504730105731774,
      11: 60.005564830272675,
      12: 72.50639955481358,
      13: 86.50751252086812
    },
    gemQty: {
      1: 0.09682804674457429,
      2: 0.09682804674457429,
      3: 0.21368948247078465,
      4: 0.27712854757929883,
      5: 0.36449638286032277,
      6: 0.48247078464106846,
      7: 0.6121313299944352,
      8: 0.775180856983862,
      9: 0.9593767390094602,
      10: 1.1608235948803562,
      11: 1.3511407902058987,
      12: 1.6010016694490818,
      13: 1.880912632164719
    }
  },
  {
    recruitmentSpeed: 200,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 1976,
    tierTime: {
      1: 2.651,
      2: 4.772,
      3: 7.688,
      4: 10.604,
      5: 14.58,
      6: 20.132,
      7: 26.51,
      8: 34.463,
      9: 43.476,
      10: 53.55,
      11: 63.623,
      12: 76.878,
      13: 91.724
    },
    gemQty: {
      13: 1.97573306370071,
      12: 1.67745197168857,
      11: 1.41253791708797,
      10: 1.2103134479272,
      9: 1.00859453993933,
      8: 0.812436804853387,
      7: 0.63953488372093,
      6: 0.501516683518706,
      5: 0.380687563195147,
      4: 0.288169868554095,
      3: 0.219413549039434,
      2: 0.151668351870576,
      1: 0.0985844287158746
    }
  },
  {
    recruitmentSpeed: 175,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 1976,
    tierTime: {
      1: 3.013,
      2: 5.423,
      3: 8.737,
      4: 12.052,
      5: 16.571,
      6: 22.898,
      7: 30.13,
      8: 39.169,
      9: 49.412,
      10: 60.862,
      11: 72.311,
      12: 87.376,
      13: 104.248
    }
  },
  {
    recruitmentSpeed: 150.7,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 1976,
    tierTime: {
      1: 3.142,
      2: 5.655,
      3: 9.112,
      4: 12.568,
      5: 17.281,
      6: 23.87,
      7: 31.421,
      8: 40.847,
      9: 51.531,
      10: 63.471,
      11: 75.411,
      12: 91.121,
      13: 108.718
    }
  },
  {
    recruitmentSpeed: 125.4,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 1976,
    tierTime: {
      1: 3.472,
      2: 6.25,
      3: 10.069,
      4: 13.889,
      5: 19.072,
      6: 26.389,
      7: 34.722,
      8: 45.139,
      9: 56.945,
      10: 70.139,
      11: 83.334,
      12: 100.695,
      13: 120.14
    }
  },
  {
    recruitmentSpeed: 102.4,
    allianceSkillBuff: 0,
    kingBuff: 0,
    troopsBatch: 1976,
    tierTime: {
      1: 3.968,
      2: 7.143,
      3: 11.508,
      4: 15.873,
      5: 21.826,
      6: 30.159,
      7: 39.683,
      8: 51.589,
      9: 65.081,
      10: 80.161,
      11: 91.597,
      12: 115.082,
      13: 137.305
    }
  }
]

export const troopsConf = {
  troopsRecruitmentRSS: {
    infantry: {
      1: { f: 60, w: 0, s: 0, i: 0 },
      2: { f: 80, w: 20, s: 0, i: 0 },
      3: { f: 134, w: 26, s: 0, i: 0 },
      4: { f: 170, w: 45, s: 3, i: 0 },
      5: { f: 212, w: 68, s: 6, i: 0 },
      6: { f: 258, w: 52, s: 12, i: 3 },
      7: { f: 304, w: 56, s: 18, i: 5 },
      8: { f: 345, w: 60, s: 25, i: 8 },
      9: { f: 381, w: 79, s: 32, i: 12 },
      10: { f: 422, w: 108, s: 40, i: 16 },
      11: { f: 522, w: 133, s: 49, i: 20 },
      12: { f: 688, w: 252, s: 66, i: 25 },
      13: { f: 891, w: 339, s: 88, i: 33 },
      14: { f: 1100, w: 440, s: 114, i: 43 }
    },
    cavalry: {
      1: { f: 0, w: 60, s: 0, i: 0 },
      2: { f: 10, w: 90, s: 0, i: 0 },
      3: { f: 41, w: 119, s: 0, i: 0 },
      4: { f: 76, w: 123, s: 6, i: 0 },
      5: { f: 110, w: 145, s: 11, i: 0 },
      6: { f: 112, w: 152, s: 19, i: 4 },
      7: { f: 113, w: 158, s: 32, i: 7 },
      8: { f: 126, w: 169, s: 41, i: 11 },
      9: { f: 143, w: 192, s: 49, i: 16 },
      10: { f: 174, w: 216, s: 58, i: 21 },
      11: { f: 215, w: 270, s: 71, i: 26 },
      12: { f: 337, w: 418, s: 83, i: 33 },
      13: { f: 440, w: 550, s: 111, i: 45 },
      14: { f: 573, w: 722, s: 145, i: 58 }
    },
    archer: {
      1: { f: 30, w: 30, s: 0, i: 0 },
      2: { f: 52, w: 48, s: 0, i: 0 },
      3: { f: 84, w: 76, s: 0, i: 0 },
      4: { f: 122, w: 88, s: 4, i: 0 },
      5: { f: 158, w: 112, s: 8, i: 0 },
      6: { f: 162, w: 119, s: 12, i: 6 },
      7: { f: 194, w: 126, s: 18, i: 9 },
      8: { f: 215, w: 135, s: 26, i: 13 },
      9: { f: 243, w: 137, s: 36, i: 18 },
      10: { f: 272, w: 138, s: 48, i: 24 },
      11: { f: 339, w: 176, s: 59, i: 29 },
      12: { f: 458, w: 297, s: 75, i: 37 },
      13: { f: 612, w: 388, s: 100, i: 50 },
      14: { f: 1100, w: 440, s: 114, i: 43 }
    },
    mage: {
      1: { f: 20, w: 40, s: 0, i: 0 },
      2: { f: 42, w: 58, s: 0, i: 0 },
      3: { f: 68, w: 92, s: 0, i: 0 },
      4: { f: 104, w: 126, s: 0, i: 0 },
      5: { f: 159, w: 141, s: 2, i: 0 },
      6: { f: 197, w: 158, s: 5, i: 2 },
      7: { f: 210, w: 190, s: 10, i: 5 },
      8: { f: 214, w: 226, s: 20, i: 7 },
      9: { f: 247, w: 258, s: 27, i: 10 },
      10: { f: 285, w: 285, s: 34, i: 15 },
      11: { f: 355, w: 355, s: 42, i: 18 },
      12: { f: 489, w: 491, s: 60, i: 22 },
      13: { f: 655, w: 655, s: 80, i: 29 },
      14: { f: 1100, w: 440, s: 114, i: 43 }
    }
  }
}
